var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancelGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Close_Icon",
    "data-name": "Close Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4561",
    "data-name": "Rectangle 4561",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(1.562 1.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13047",
    "data-name": "Group 13047",
    transform: "translate(0 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026123480862262695870000014710365773972803006_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-2",
    "data-name": "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M10.435,20.9A10.441,10.441,0,0,1,3.056,3.08l.431.431L3.056,3.08A10.441,10.441,0,1,1,10.435,20.9Zm0-19.657a9.217,9.217,0,1,0,6.516,2.7,9.216,9.216,0,0,0-6.516-2.7Z",
    transform: "translate(0 -0.022)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5789",
    "data-name": "Path 5789",
    d: "M156.291,163.745a.612.612,0,0,1-.433-1.044l6.948-6.948a.612.612,0,0,1,.88.85l-.015.015-6.948,6.948A.612.612,0,0,1,156.291,163.745Z",
    transform: "translate(-149.33 -149.219)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5790",
    "data-name": "Path 5790",
    d: "M163.064,163.745a.612.612,0,0,1-.433-.179l-6.948-6.948a.612.612,0,0,1,.85-.88l.015.015L163.5,162.7a.612.612,0,0,1-.432,1.044Z",
    transform: "translate(-149.155 -149.219)",
    fill: "#101820"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelGrey);
export default __webpack_public_path__ + "static/media/icon_cancel_grey.8f6628b4b41a3e613f273a3694b8891e.svg";
export { ForwardRef as ReactComponent };